import { render, staticRenderFns } from "./crumbs.vue?vue&type=template&id=3bd62766&scoped=true"
import script from "./crumbs.vue?vue&type=script&lang=js"
export * from "./crumbs.vue?vue&type=script&lang=js"
import style0 from "./crumbs.vue?vue&type=style&index=0&id=3bd62766&scoped=true&lang=scss"
import style1 from "./crumbs.vue?vue&type=style&index=1&id=3bd62766&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd62766",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd62766')) {
      api.createRecord('3bd62766', component.options)
    } else {
      api.reload('3bd62766', component.options)
    }
    module.hot.accept("./crumbs.vue?vue&type=template&id=3bd62766&scoped=true", function () {
      api.rerender('3bd62766', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/crumbs.vue"
export default component.exports